import { render, staticRenderFns } from "./BadgeItem.vue?vue&type=template&id=022363af&"
import script from "./BadgeItem.vue?vue&type=script&lang=ts&"
export * from "./BadgeItem.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports